var map = {
	"./G.svg": 227,
	"./arrow-down-blue.svg": 512,
	"./arrow-down-grey.svg": 513,
	"./arrow-right-white.png": 514,
	"./arrow-right.svg": 515,
	"./bg-h5.png": 516,
	"./bg-web.png": 517,
	"./blue-loader.svg": 228,
	"./body-bg-modal.png": 229,
	"./bridge.png": 182,
	"./circle-grey.svg": 518,
	"./circle.svg": 519,
	"./coinbaseWalletIcon.svg": 154,
	"./dropdown-blue.svg": 520,
	"./dropdown.svg": 521,
	"./dropup-blue.svg": 522,
	"./ethereum-logo.png": 523,
	"./footer-logo.svg": 185,
	"./fortmaticIcon.png": 156,
	"./link.svg": 524,
	"./magnifying-glass.svg": 525,
	"./menu.svg": 526,
	"./metagod.png": 527,
	"./metamask.png": 230,
	"./plus-blue.svg": 528,
	"./plus-grey.svg": 529,
	"./portisIcon.png": 153,
	"./question-mark.svg": 530,
	"./question.svg": 531,
	"./spinner.svg": 532,
	"./token-list/lists-dark.png": 533,
	"./token-list/lists-light.png": 534,
	"./trustWallet.png": 535,
	"./walletConnectIcon.svg": 155,
	"./x.svg": 536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;